import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { trans } from '../../../localization/language';
import * as emailActions from '../../../actions/email';

class NotBindEmail extends React.Component {
	handleClick() {
		this.props.initEmail();
	}

	render() {
		return (
			<div className="content">
				<div className="content-item content-item--ipage">
					<div className="content-item__title">
						{trans('setup_google_authenticator_title')}
					</div>
					<div className="content-item__main">
						<div className="content-item--ipage__main">
							<div className="content__result">
								<div className="content__result-icon"></div>
								<div className="content__result-txt">
									{trans('authenticator_no_email_warning')}
								</div>
							</div>
							<div className="setupauth-binddesc">
								{trans('authenticator_no_email_description')}
							</div>
							<div className="content__submit-wrap">
								<a className="content__submit" href="#" onClick={this.handleClick.bind(this)}>
									{trans('bind_email_btn')}
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(Object.assign({}, emailActions), dispatch);
}

export default connect(null, mapDispatchToProps)(NotBindEmail);


// WEBPACK FOOTER //
// ./app/components/security/authenticator/NotBindEmail.js